
let scrollDownToGetData = {
	bind(el, binding, vnode) {
		let scrollTop = el.scrollTop;
		let fullHeight = el.scrollHeight;
		let viewHeight = el.offsetHeight;
		el.addEventListener('scroll', (e) => {
			let newScrollTop = el.scrollTop;

			if (newScrollTop < scrollTop) {
				scrollTop = newScrollTop;
				return
			}
			scrollTop = newScrollTop;
			fullHeight = el.scrollHeight;
			viewHeight = el.offsetHeight;
			// console.log(scrollTop);
			if (fullHeight - scrollTop < viewHeight * 1.5) {
				// console.log(vnode)
				// vnode.$emit('getNextData')
				if (typeof binding.value == 'function') {
					binding.value()
				}
			}
		});
	}
}

export {
	scrollDownToGetData
}

